import { Injectable, inject } from '@angular/core'
import { User, UserWithCompany } from '../types/users'
import { environment } from '../../environments/environment'
import { Observable, catchError, map } from 'rxjs'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { ErrorService } from './error.service'

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'users'

  create(user: User): Observable<boolean> {
    let headers = new HttpHeaders()
    headers = headers.append('content-type', 'application/json')

    return this.http.post<boolean>(this.URL, user, { headers }).pipe(
      map((res: boolean) => {
        return res || false
      }),
      catchError(this.errorService.handleError),
    )
  }

  getAll(): Observable<Array<User>> {
    return this.http
      .get<Array<User>>(this.URL)
      .pipe(catchError(this.errorService.handleError))
  }

  /**
   * Sends request to create a user as a master user
   * @param {UserWithCompany} user The user to create
   * @returns {null}
   */
  createWithCompany(user: UserWithCompany): Observable<null> {
    return this.http
      .post<null>(this.URL + '/create-with-company', user)
      .pipe(catchError(this.errorService.handleError))
  }
}
